// extracted by mini-css-extract-plugin
export default {"appWrapperOwner":"MainPage_appWrapperOwner__xBVXd","appWrapper":"MainPage_appWrapper__dDfWy","bgStar":"MainPage_bgStar__2AHyh","bgStarWrapper":"MainPage_bgStarWrapper__jO0td"};